module.exports = __webpack_public_path__ + "img/color_spring_clothes.b6925f75.png";